import { isAfter, isToday } from '@eneco/common/date';
import { AdvanceAmountCollectionResponse, AdvanceAmountDto } from '@eneco/dc-be/client';

export const filteredAdvancesWithActiveContractAndCurrentAmount = ({
  advances,
}: {
  advances: AdvanceAmountCollectionResponse | undefined | null;
}): AdvanceAmountCollectionResponse | null => {
  const filteredAdvancePayments =
    advances?.advancePayments?.filter(ap => hasAdvanceAmountForContract({ advance: ap })) ?? [];
  return { ...advances, totals: advances?.totals ?? {}, advancePayments: filteredAdvancePayments };
};

export const hasActiveContract = ({ advance }: { advance: AdvanceAmountDto | undefined }): boolean => {
  if (!advance?.contractDetails?.contractStartDate) {
    return false;
  }

  const { contractExpiryDate } = advance.contractDetails;

  return contractExpiryDate == null || isToday(contractExpiryDate) || isAfter(contractExpiryDate, new Date());
};

export const hasAdvanceAmountForContract = ({ advance }: { advance: AdvanceAmountDto | undefined }): boolean => {
  if (!advance?.contractDetails?.contractStartDate) {
    return false;
  }

  const { details, meterDetails } = advance;

  if (meterDetails?.invoiceFrequency === 'Yearly') {
    return !details?.notAvailable && details?.currentAmount != null;
  }

  return hasActiveContract({ advance });
};

export const hasAdvanceAmountForContracts = ({
  advances,
}: {
  advances: AdvanceAmountCollectionResponse | undefined | null;
}): boolean => {
  return !!advances?.advancePayments?.some(advance => hasAdvanceAmountForContract({ advance }));
};
